import browser from "webextension-polyfill";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { prepareInlineScriptForInjection } from "@eyeo/webext-ad-filtering-solution/adblockpluscore/lib/snippets.js";
import { detectionEvent } from "../shared/index.js";
import { uboDetectedKey, uboDetectionLastRunKey, uboExtensionIds, } from "./detection.types.js";
const urlMatches = [
    { hostEquals: "www.youtube.com" },
    { hostEquals: "youtube.com" },
    { hostEquals: "www.facebook.com" },
    { hostEquals: "facebook.com" },
];
const btUrls = ["*://btloader.com/tag?*"];
const serverLogger = new ewe.telemetry.ServerLogger("conflict_detection");
function uboDetection(eventName) {
    const jsonIn = `{"require":{"0":{"3":{"0":{"__bbox":{"require":[{"3":{"1":{"__bbox":{"result":{"data":{"serpResponse":{"results":{"edges":[{"rendering_strategy":{"view_model":{"story":{"sponsored_data":{"ad_id":"this_will_be_removed"}}}}}]}}}}}}}}]}}}}}}`;
    const jsonOut = JSON.stringify(JSON.parse(jsonIn));
    const XHRChanged = XMLHttpRequest.toString().includes("uboLog");
    const result = jsonIn !== jsonOut || XHRChanged;
    if (!result) {
        return false;
    }
    if (eventName) {
        document.dispatchEvent(new CustomEvent(eventName));
    }
    return result;
}
async function saveResultInPrefs(prefs, key) {
    await prefs.untilLoaded;
    await prefs.set(key, Date.now());
}
async function runMV3Detection(logger, prefs, tabId) {
    try {
        const [{ result }] = await browser.scripting.executeScript({
            target: { tabId },
            func: uboDetection,
            world: "MAIN",
        });
        logger.debug("[conflict-detection]: non-partner extension MV3 detection script was injected");
        if (!result) {
            logger.debug("[conflict-detection]: NO non-partner extension was found on MV3");
            return;
        }
    }
    catch (error) {
        logger.error("[conflict-detection]: Error running MV3 detection script", error);
        return;
    }
    logger.debug("[conflict-detection]: non-partner extension found on MV3");
    await saveResultInPrefs(prefs, uboDetectedKey);
}
async function runMV2Detection(logger, tabId) {
    const executable = prepareInlineScriptForInjection(uboDetection, detectionEvent);
    try {
        await browser.tabs.executeScript(tabId, {
            frameId: 0,
            code: executable,
            matchAboutBlank: true,
            runAt: "document_end",
        });
        logger.debug("[conflict-detection]: non-partner extension MV2 detection script was injected");
    }
    catch (error) {
        logger.error("[conflict-detection]: Error running MV2 detection script", error);
    }
}
export function start(parameters) {
    const { logger, port, addTrustedMessageTypes, prefs } = parameters;
    browser.webNavigation.onCompleted.addListener(async (details) => {
        var _a, _b;
        const { tabId, frameId } = details;
        if (frameId !== 0 || tabId === -1) {
            return;
        }
        if (((_a = browser.scripting) === null || _a === void 0 ? void 0 : _a.executeScript) &&
            Object.values((_b = browser.scripting.ExecutionWorld) !== null && _b !== void 0 ? _b : {}).includes("MAIN")) {
            await runMV3Detection(logger, prefs, tabId);
        }
        else {
            await runMV2Detection(logger, tabId);
        }
        await saveResultInPrefs(prefs, uboDetectionLastRunKey);
    }, {
        url: urlMatches,
    });
    urlMatches.forEach(({ hostEquals: host }) => {
        addTrustedMessageTypes(`https://${host}`, [detectionEvent]);
    });
    port.on(detectionEvent, async () => {
        await saveResultInPrefs(prefs, uboDetectedKey);
        logger.debug("[conflict-detection]: non-partner extension found on MV2");
    });
    browser.tabs.onCreated.addListener(async (tab) => {
        const { url, pendingUrl, title } = tab;
        const tabUrl = url && url !== "" ? url : pendingUrl;
        if (!tabUrl) {
            return;
        }
        const isPartnerExtension = uboExtensionIds.some((extensionId) => tabUrl.includes(`/${extensionId}/`) || (title === null || title === void 0 ? void 0 : title.includes(extensionId)));
        if (isPartnerExtension) {
            logger.debug("[conflict-detection]: non-partner extension found by options page");
            await saveResultInPrefs(prefs, uboDetectionLastRunKey);
            await saveResultInPrefs(prefs, uboDetectedKey);
        }
    });
    browser.webRequest.onErrorOccurred.addListener((details) => {
        serverLogger.info("bt_loader_blocked", details.error);
    }, { urls: btUrls, types: ["script"] });
}
